(function(){
  'use strict';

  // Pre-fill full cart widget (my-delivery-widget) from localStorage
  // Runs on every page load — safe because it checks !_kPlz.value first
  try {
    var _saved = localStorage.getItem('mfl_plz') || '';
    var _kPlz  = document.getElementById('mdw-kurier-plz');
    var _dPlz  = document.getElementById('mdw-dpd-plz');
    if (_kPlz && !_kPlz.value && _saved.length === 5) {
      _kPlz.value = _saved;
      _kPlz.dispatchEvent(new Event('input', { bubbles: true }));
    }
    if (_dPlz && !_dPlz.value && _saved.length === 5) {
      _dPlz.value = _saved;
    }
  } catch(e){}

  var root = document.getElementById('mdwc');
  if (!root) return; // Not on product page — compact widget done

  // Guard against double-init using DOM attribute (survives SPA navigation resets)
  if (root.getAttribute('data-mdwc-init')) return;
  root.setAttribute('data-mdwc-init', '1');

  var S_ok      = root.getAttribute('data-s-ok')       || '';
  var S_bad     = root.getAttribute('data-s-bad')      || '';
  var S_hint    = root.getAttribute('data-s-hint')     || '';
  var S_far     = root.getAttribute('data-s-far')      || '';
  var S_far_hint= root.getAttribute('data-s-far-hint') || '';
  var S_far_cta = root.getAttribute('data-s-far-cta')  || '';
  var S_range   = root.getAttribute('data-s-range')    || '';
  var S_free_from = root.getAttribute('data-s-free-from') || '';
  var S_free      = root.getAttribute('data-s-free')      || '';
  var S_exact   = root.getAttribute('data-s-exact')    || '';
  var S_edge    = root.getAttribute('data-s-edge')     || '';
  var S_cost    = root.getAttribute('data-s-cost')     || '';
  function fmtEur(n){
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de', { style:'currency', currency:'EUR', maximumFractionDigits:0 }).format(n); }
    catch(e){ return n + ' €'; }
  }

  var PLZ_ZONES = {
    // ERZEUGT von tools/gen_plz_tables.py — nicht von Hand aendern.
    // Quelle: Shopify Lokale Zustellung, Radius 35 km Luftlinie ab Achwaldstr. 4d,
    // Stufen 0/16/21/27/33/39 EUR bei 3/8/13/19/25/35 km.
    '80331':2,'80333':2,'80335':2,'80336':2,'80337':2,'80339':2,'80469':2,
    '80538':2,'80539':2,'80634':1,'80636':1,'80637':1,'80638':1,'80639':1,
    '80686':1,'80687':1,'80689':1,'80796':2,'80797':2,'80798':2,'80799':2,
    '80801':2,'80802':2,'80803':2,'80804':2,'80805':2,'80807':2,'80809':1,
    '80933':1,'80935':1,'80937':2,'80939':2,'80992':1,'80993':1,'80995':0,
    '80997':0,'80999':0,'81241':1,'81243':1,'81245':1,'81247':0,'81249':0,
    '81369':2,'81371':2,'81373':2,'81375':2,'81377':2,'81379':2,'81475':2,
    '81476':2,'81477':2,'81479':2,'81539':3,'81541':2,'81543':2,'81545':3,
    '81547':2,'81549':3,'81667':2,'81669':2,'81671':3,'81673':3,'81675':2,
    '81677':3,'81679':2,'81735':3,'81737':3,'81739':2,'81825':3,'81827':3,
    '81829':3,'81925':2,'81927':3,'81929':3,'82008':3,'82024':4,'82031':3,
    '82041':3,'82049':3,'82054':4,'82057':4,'82061':2,'82064':2,'82065':3,
    '82067':4,'82069':4,'82110':1,'82131':2,'82140':1,'82152':2,'82166':1,
    '82178':1,'82194':1,'82205':2,'82211':4,'82216':2,'82223':2,'82229':3,
    '82234':3,'82237':3,'82239':2,'82256':2,'82266':4,'82269':5,'82272':4,
    '82275':2,'82276':4,'82278':4,'82279':5,'82281':3,'82284':4,'82285':4,
    '82287':4,'82288':4,'82290':3,'82291':3,'82293':4,'82294':4,'82296':3,
    '82297':5,'82299':4,'82319':3,'82327':5,'82335':4,'82340':5,'82343':4,
    '82346':4,'82347':5,'82349':2,'82396':5,'82515':5,'82538':5,'82541':5,
    '82544':5,'82547':5,'83607':5,'83623':5,'83624':5,'83626':5,'85221':1,
    '85229':2,'85232':0,'85235':3,'85238':4,'85241':2,'85244':2,'85247':2,
    '85250':3,'85253':3,'85254':2,'85256':3,'85258':3,'85259':3,'85276':5,
    '85293':5,'85298':5,'85301':5,'85302':5,'85304':5,'85305':4,'85307':5,
    '85354':4,'85356':4,'85375':3,'85376':3,'85386':2,'85391':4,'85395':5,
    '85399':4,'85402':4,'85406':5,'85411':4,'85414':5,'85416':5,'85417':5,
    '85435':5,'85445':5,'85452':4,'85457':5,'85462':5,'85464':4,'85467':4,
    '85521':4,'85540':4,'85551':4,'85560':5,'85570':5,'85579':3,'85586':4,
    '85591':4,'85598':5,'85599':4,'85604':5,'85609':3,'85614':5,'85622':4,
    '85625':5,'85630':4,'85635':5,'85640':4,'85646':5,'85649':4,'85652':4,
    '85653':5,'85658':5,'85661':5,'85662':4,'85665':5,'85667':5,'85669':5,
    '85716':1,'85737':3,'85748':2,'85757':0,'85764':1,'85774':3,'85777':3,
    '85778':2,'86316':5,'86415':5,'86438':5,'86453':5,'86492':5,'86495':4,
    '86504':5,'86510':4,'86511':5,'86551':5,'86556':5,'86559':5,'86561':5,
    '86565':5,'86567':4,'86576':5,'86577':5,'86911':5,'86919':5,'86922':5,
    '86923':5,'86926':5,'86938':5,'86941':5,'86947':5,'86949':5
  };
  // Versandkosten rechnet Shopify Local Delivery (per Distanz vom Shop). Wir prüfen nur
  // ob die PLZ im Liefergebiet liegt — die Spanne 0–39€ wird als Hinweis angezeigt.
  var PLZ_FAR = {
    // knapp ausserhalb des Radius.

  }; // Rest seit 2026-09-14 in PLZ_ZONES (Shopify liefert dorthin)
  // Kurier-Preisspanne je PLZ (Stand 2026-09-14): Shopify-Stufen (Luftlinie ab Achwaldstr. 4d) über die
  // Ausdehnung der PLZ (Photon-Extent + Mittelpunkt). Gegen alle gemessenen Shopify-Preise geprüft.
  // [min €, max €, 1 = Randlagen über 35 km → evtl. nur DPD]. Exakter Preis: Warenkorb-Widget nach Adresse.
  var PLZ_PRICE = {
    // [min EUR, max EUR, 1 = Teil der PLZ jenseits des Radius].
    '80331':[21, 21],'80333':[21, 21],'80335':[21, 21],'80336':[21, 21],'80337':[21, 21],'80339':[21, 21],
    '80469':[21, 27],'80538':[21, 27],'80539':[21, 21],'80634':[16, 21],'80636':[16, 21],'80637':[16, 21],
    '80638':[16, 21],'80639':[16, 21],'80686':[16, 21],'80687':[16, 21],'80689':[16, 21],'80796':[21, 21],
    '80797':[21, 21],'80798':[21, 21],'80799':[21, 21],'80801':[21, 21],'80802':[21, 21],'80803':[21, 21],
    '80804':[21, 21],'80805':[21, 27],'80807':[21, 21],'80809':[16, 21],'80933':[16, 21],'80935':[16, 21],
    '80937':[21, 21],'80939':[21, 27],'80992':[16, 21],'80993':[16, 16],'80995':[0, 21],'80997':[0, 16],
    '80999':[0, 16],'81241':[16, 21],'81243':[16, 16],'81245':[16, 16],'81247':[0, 16],'81249':[0, 21],
    '81369':[21, 27],'81371':[21, 27],'81373':[21, 21],'81375':[21, 21],'81377':[21, 21],'81379':[21, 27],
    '81475':[21, 27],'81476':[21, 27],'81477':[21, 27],'81479':[21, 27],'81539':[27, 27],'81541':[21, 27],
    '81543':[21, 27],'81545':[27, 27],'81547':[21, 27],'81549':[27, 27],'81667':[21, 27],'81669':[21, 27],
    '81671':[27, 27],'81673':[27, 27],'81675':[21, 27],'81677':[27, 27],'81679':[21, 27],'81735':[27, 33],
    '81737':[27, 33],'81739':[21, 33],'81825':[27, 33],'81827':[27, 33],'81829':[27, 33],'81925':[21, 27],
    '81927':[27, 27],'81929':[27, 33],'82008':[27, 33],'82024':[33, 39],'82031':[27, 33],'82041':[27, 39],
    '82049':[27, 33],'82054':[33, 39, 1],'82057':[33, 39],'82061':[21, 33],'82064':[21, 39],'82065':[27, 33],
    '82067':[33, 39],'82069':[33, 33],'82110':[16, 27],'82131':[21, 33],'82140':[16, 21],'82152':[21, 27],
    '82166':[16, 21],'82178':[16, 21],'82194':[16, 16],'82205':[21, 33],'82211':[33, 39, 1],'82216':[21, 33],
    '82223':[21, 21],'82229':[27, 39],'82234':[27, 33],'82237':[27, 39],'82239':[21, 27],'82256':[21, 33],
    '82266':[33, 39],'82269':[39, 39, 1],'82272':[33, 39],'82275':[21, 27],'82276':[33, 39],'82278':[33, 39],
    '82279':[39, 39],'82281':[27, 39],'82284':[33, 39],'82285':[33, 39],'82287':[33, 39],'82288':[33, 39],
    '82290':[27, 33],'82291':[27, 33],'82293':[33, 39],'82294':[33, 39],'82296':[27, 33],'82297':[39, 39],
    '82299':[33, 39],'82319':[27, 39],'82327':[39, 39, 1],'82335':[33, 39],'82340':[39, 39],'82343':[33, 39],
    '82346':[33, 39, 1],'82347':[39, 39, 1],'82349':[21, 27],'82396':[39, 39, 1],'82515':[39, 39],'82538':[39, 39, 1],
    '82541':[39, 39, 1],'82544':[39, 39, 1],'82547':[39, 39, 1],'83607':[39, 39, 1],'83623':[39, 39, 1],'83624':[39, 39, 1],
    '83626':[39, 39, 1],'85221':[16, 27],'85229':[21, 39],'85232':[0, 27],'85235':[27, 39],'85238':[33, 39],
    '85241':[21, 27],'85244':[21, 27],'85247':[21, 33],'85250':[27, 39],'85253':[27, 39],'85254':[21, 33],
    '85256':[27, 33],'85258':[27, 33],'85259':[27, 33],'85276':[39, 39, 1],'85293':[39, 39],'85298':[39, 39, 1],
    '85301':[39, 39, 1],'85302':[39, 39, 1],'85304':[39, 39, 1],'85305':[33, 39],'85307':[39, 39, 1],'85354':[33, 39, 1],
    '85356':[33, 39, 1],'85375':[27, 39],'85376':[27, 39],'85386':[21, 33],'85391':[33, 39],'85395':[39, 39, 1],
    '85399':[33, 39],'85402':[33, 39],'85406':[39, 39, 1],'85411':[33, 39],'85414':[39, 39, 1],'85416':[39, 39, 1],
    '85417':[39, 39, 1],'85435':[39, 39, 1],'85445':[39, 39, 1],'85452':[33, 39],'85457':[39, 39, 1],'85462':[39, 39, 1],
    '85464':[33, 39],'85467':[33, 39],'85521':[33, 39],'85540':[33, 39],'85551':[33, 39],'85560':[39, 39, 1],
    '85570':[39, 39],'85579':[27, 33],'85586':[33, 39],'85591':[33, 39],'85598':[39, 39],'85599':[33, 39],
    '85604':[39, 39],'85609':[27, 33],'85614':[39, 39, 1],'85622':[33, 39],'85625':[39, 39, 1],'85630':[33, 39],
    '85635':[39, 39],'85640':[33, 39],'85646':[39, 39],'85649':[33, 39, 1],'85652':[33, 39],'85653':[39, 39, 1],
    '85658':[39, 39, 1],'85661':[39, 39, 1],'85662':[33, 39],'85665':[39, 39, 1],'85667':[39, 39, 1],'85669':[39, 39, 1],
    '85716':[16, 27],'85737':[27, 33],'85748':[21, 33],'85757':[0, 16],'85764':[16, 27],'85774':[27, 27],
    '85777':[27, 39],'85778':[21, 33],'86316':[39, 39, 1],'86415':[39, 39, 1],'86438':[39, 39, 1],'86453':[39, 39, 1],
    '86492':[39, 39, 1],'86495':[33, 39],'86504':[39, 39, 1],'86510':[33, 39, 1],'86511':[39, 39, 1],'86551':[39, 39, 1],
    '86556':[39, 39, 1],'86559':[39, 39],'86561':[39, 39, 1],'86565':[39, 39, 1],'86567':[33, 39],'86576':[39, 39, 1],
    '86577':[39, 39],'86911':[39, 39, 1],'86919':[39, 39, 1],'86922':[39, 39, 1],'86923':[39, 39, 1],'86926':[39, 39],
    '86938':[39, 39],'86941':[39, 39],'86947':[39, 39, 1],'86949':[39, 39, 1]
  };

  function getEl(id){ return document.getElementById(id); }

  // ── Echter Preis von Shopify, wenn der Warenkorb es hergibt ──
  // Ohne Artikel im Warenkorb gibt Shopify keine Rate zurueck — dann bleibt es bei der
  // Spanne aus PLZ_PRICE. Mit Artikeln liefert schon die PLZ allein den exakten Preis.
  function isCourierRate(r){
    if (!r) return false;
    if (r.phone_required === true) return true;
    return String(r.code || r.name || '').toLowerCase().indexOf('local delivery') !== -1;
  }
  var cartInfo = null, cartInfoAt = 0;
  function loadCart(cb){
    if (cartInfo && Date.now() - cartInfoAt < 30000){ cb(cartInfo); return; }
    fetch('/cart.js', { credentials:'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(c){ cartInfo = { count: c.item_count, total: c.total_price/100 }; cartInfoAt = Date.now(); cb(cartInfo); })
      .catch(function(){ cb(null); });
  }
  var rateTimer = null, rateCache = {};
  // Warenkorb geaendert -> Preise neu holen (Gratis-Schwelle, Mindestbestellwert)
  document.addEventListener('mfl:cart-updated', function(){ cartInfo = null; rateCache = {}; });
  function scheduleShopRate(plz){
    if (rateTimer) clearTimeout(rateTimer);
    rateTimer = setTimeout(function(){ fetchShopRate(plz); }, 900);
  }
  function fetchShopRate(plz){
    loadCart(function(cart){
      if (!cart || !cart.count) return;                     // ohne Warenkorb keine Auskunft
      var ck = plz + '|' + cart.total;
      if (rateCache[ck] !== undefined){ applyShopRate(plz, rateCache[ck]); return; }
      var q = 'shipping_address[zip]=' + encodeURIComponent(plz) + '&shipping_address[country]=Germany';
      fetch('/cart/shipping_rates.json?' + q, { credentials:'same-origin' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(d){
          var rates = (d && d.shipping_rates) || [];
          var kurier = rates.filter(isCourierRate)[0];
          // NUR positive Antworten verwerten. Eine fehlende Kurier-Rate kann auch
          // Drosselung oder Mindestbestellwert bedeuten — daraus darf nie eine
          // Absage werden. Dann bleibt die Tabellen-Antwort stehen.
          var res = kurier ? parseFloat(kurier.price) : null;
          if (res !== null) rateCache[ck] = res;
          applyShopRate(plz, res);
        })
        .catch(function(){});
    });
  }
  // Ergebnis anwenden — nur, wenn im Feld noch dieselbe PLZ steht.
  function applyShopRate(plz, res){
    if (res === null || res === undefined) return;
    var input = getEl('mdwc-plz');
    if (!input || input.value !== plz) return;
    var rEl = getEl('mdwc-result'), iEl = getEl('mdwc-result-icon'),
        tEl = getEl('mdwc-result-text'), pEl = getEl('mdwc-result-price');
    var waBtn = getEl('mdwc-wa-btn'), waLbl = getEl('mdwc-wa-label');
    if (!rEl) return;
    var methods = root.querySelectorAll('.mdwc-method');
    function highlight(name){ methods.forEach(function(m){ m.classList.toggle('on', m.getAttribute('data-m') === name); }); }
    rEl.className = 'mdwc-result ok'; rEl.style.display = 'flex';   // exakter Preis
    if (iEl) iEl.className = 'at at-check';
    if (waBtn) waBtn.style.display = 'none';
    var extra = [];
    if (res > 0 && S_free_from) extra.push(S_free_from.replace('%s', fmtEur(250)));
    // Hinweis bleibt stehen: der Preis gilt fuer den JETZIGEN Warenkorb — legt der Kunde
    // dieses Produkt noch dazu, kann er sich aendern (z. B. Gratis-Schwelle).
    if (tEl) tEl.innerHTML = '<strong>' + (S_cost || S_ok) + '</strong>' +
                             (extra.length ? ' · ' + extra.join(' · ') : '') +
                             (S_exact ? '<small class="mdwc-exact">' + S_exact + '</small>' : '');
    if (pEl) pEl.textContent = res === 0 ? S_free : fmtEur(res);
    highlight('kurier');
    try { localStorage.setItem('mfl_method','kurier'); } catch(e){}
  }

  function check(val){
    var rEl   = getEl('mdwc-result');
    var iEl   = getEl('mdwc-result-icon');
    var tEl   = getEl('mdwc-result-text');
    var pEl   = getEl('mdwc-result-price');
    var waBtn = getEl('mdwc-wa-btn');
    var waLbl = getEl('mdwc-wa-label');
    if (!rEl) return;

    var methods = root.querySelectorAll('.mdwc-method');
    function highlight(name){ methods.forEach(function(m){ m.classList.toggle('on', m.getAttribute('data-m') === name); }); }
    function hideWa(){ if (waBtn) waBtn.style.display = 'none'; }
    function showWa(){ if (waLbl) waLbl.textContent = S_far_cta; if (waBtn) waBtn.style.display = 'flex'; }

    if (val.length < 5){
      rEl.style.display = 'none';
      hideWa();
      methods.forEach(function(m){ m.classList.remove('on'); });
      return;
    }
    var z = PLZ_ZONES[val];
    if (z !== undefined){
      rEl.className = 'mdwc-result ok'; rEl.style.display = 'flex';
      if (iEl) iEl.className = 'at at-check';
      var pr = PLZ_PRICE[val];
      if (pr && tEl && pEl){
        var extra = [];
        if (pr[0] < 39 && S_free_from) extra.push(S_free_from.replace('%s', fmtEur(250)));
        if (pr[2] && S_edge) extra.push(S_edge);
        tEl.innerHTML = '<strong>' + (S_cost || S_ok) + '</strong>' + (extra.length ? ' · ' + extra.join(' · ') : '') +
                        (S_exact ? '<small class="mdwc-exact">' + S_exact + '</small>' : '');
        var maxTxt = fmtEur(pr[1]);
        // Währungssymbol nur einmal: DE/RU „21–27 €“, EN „€21–27“
        pEl.textContent = pr[0] === pr[1] ? maxTxt
          : (/^\D/.test(maxTxt) ? maxTxt.replace(/[\d.,\s]+$/, '') + pr[0] + '–' + pr[1] : pr[0] + '–' + maxTxt);
      } else {
        if (tEl) tEl.innerHTML = '<strong>' + S_ok + '</strong> ' + S_range;
        if (pEl) pEl.textContent = '';
      }
      hideWa(); highlight('kurier');
      try { localStorage.setItem('mfl_method','kurier'); } catch(e){}
    } else if (PLZ_FAR[val]) {
      rEl.className = 'mdwc-result far'; rEl.style.display = 'flex';
      if (iEl) iEl.className = 'at at-map-marker-al';
      if (tEl) tEl.innerHTML = '<strong>' + S_far + '</strong> ' + S_far_hint;
      if (pEl) pEl.textContent = '';
      showWa(); highlight('dpd');
      try { localStorage.setItem('mfl_method','dpd'); } catch(e){}
    } else {
      rEl.className = 'mdwc-result bad'; rEl.style.display = 'flex';
      if (iEl) iEl.className = 'at at-times-r';
      if (tEl) tEl.innerHTML = '<strong>' + S_bad + '</strong> ' + S_hint;
      if (pEl) pEl.textContent = '';
      hideWa(); highlight('dpd');
      try { localStorage.setItem('mfl_method','dpd'); } catch(e){}
    }
    try { localStorage.setItem('mfl_plz', val); } catch(e){}
    scheduleShopRate(val);   // Tabellen-Antwort ggf. durch die echte Rate ersetzen
    if (val.length === 5){
      try {
        fetch('/cart/update.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ attributes: { 'PLZ': val } })
        }).catch(function(){});
      } catch(e){}
    }
  }

  var plzInput = getEl('mdwc-plz');
  if (plzInput) {
    var _lastVal = '';
    function handlePlz() {
      var v = plzInput.value.replace(/\D/g,'').slice(0,5);
      if (v !== plzInput.value) { plzInput.value = v; }
      if (v !== _lastVal) { _lastVal = v; check(v); }
    }
    plzInput.addEventListener('input',  handlePlz);
    plzInput.addEventListener('keyup',  handlePlz);
    plzInput.addEventListener('change', handlePlz);
    // Polling fallback — catches paste, autofill, mobile edge cases
    setInterval(function(){ if (plzInput.value !== _lastVal) handlePlz(); }, 400);
    try {
      var initPlz = localStorage.getItem('mfl_plz') || '';
      if (initPlz.length === 5) {
        plzInput.value = initPlz;
        check(initPlz);
      }
    } catch(e){}
  }
})();
